import { useContext } from 'react';

import { isDev } from '@shared/utils/environment';

import { LayoutViewBridge, LayoutViewContext } from './LayoutViewContext';

const useLayoutViewContext = () => {
  const context = useContext(LayoutViewContext);

  if (context) {
    return context;
  }

  if (isDev()) {
    console.warn(
      'useLayoutViewContext resolved outside LayoutViewContextProvider — falling back to the location-derived layout view.'
    );
  }

  // Imperatively rendered subtrees (antd `Modal.confirm`, `notification.open`) are mounted in a
  // detached React root, so they sit outside the provider. Fall back to the bridge, which the
  // provider keeps in sync on every route change and which resolves the layout view from
  // `window.location` when the provider has not mounted at all.
  return LayoutViewBridge.getLayoutViewBridge();
};

export { useLayoutViewContext };
